import jsdk from '../../jsdk';
import t from 'tcomb';
import Text from './Text';
import Image from './Image';
import HText_Component_Style from './style/HText_Component_Style';
import cloneDeep from 'lodash/lang/cloneDeep';
import micromd from '../../micromd';

const text_representation = (text) => {

  var tag = 'div';
  var content = micromd(String(text.value)); // rendering del markdown contenuto in .value

  // come stile la dimensione del testo è una gestione a parte
  // e viene indicato con il parametro size invece che font-size
  // per distinguerlo dalla proprietà css
  //
  // se size è un numerico viene interpretato come font-size in pixel
  // e il line-height viene impostato automaticamente
  //
  // se invece size è una stringa viene interpretata in modo semantico
  // e tradotta con questi tag:
  // - small: small
  // - normal: div
  // - medium: h3
  // - large: h2

  var style = cloneDeep(text.style);

  if (style.size) {

    var size = style.size;
    delete style.size;

    if (t.Number.is(size)) {
      style['font-size'] = size;
      style['line-height'] = parseInt(size * 1.5, 10);
    } else {
      switch (size) {
        case 'small':
          tag = 'small';
          break;
        case 'medium':
          tag = 'h3';
          break;
        case 'large':
          tag = 'h2';
          break;
      }
    }
  }

  return {
    tag: tag,
    attrs: {
      style: style
    },
    content: content
  };
};

const HText_Component = t.struct({
  text: t.maybe(Text),
  image: t.maybe(Image),
  style: HText_Component_Style
}, 'HText_Component');


HText_Component.prototype.to_form = function() {
  var html;
  var image = '';
  var text = '';
  if (this.image) {
    image += !t.Nil.is(this.image.link) ? '<a href="' + this.image.link + '" target="_blank">' : '';
    image += '<img' + jsdk.attr({
      src: this.image.src
    }) + '/>';
    image += !t.Nil.is(this.image.link) ? '</a>' : '';
  }
  if (this.text) {
    var repr = text_representation(this.text);
    text = jsdk.dom[repr.tag](repr.content, repr.attrs);
  }
  if (this.image && this.text) {
    if (this.text.position === 'right') {
      html = '<div class="large-45 small-100">' + image + '</div><div class="large-45 large-pull-right small-100">' + text + '</div>';
    }
    else {
      html = '<div class="large-45 large-pull-right small-100">' + image + '</div><div class="large-45 large-pull-left small-100">' + text + '</div>';
    }
  }
  else {
    html = image + text;
  }
  var style = this.style;
  if (style.height) {
    style = t.mixin({
      overflow: 'auto'
    }, style);
  }
  return '<div' + jsdk.attr({
    style: style
  }) + '>' + html + '</div>';
};

export default HText_Component;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/HText_Component.js
 **/